import BlockTypes from '../../../types/BlockTypes';
/**
 * Indent all lines in selection
 */

function indentLines(editor, // Indent to add
indent) {
  var value = editor.value;
  var document = value.document,
      selection = value.selection;
  var lines = document.getLeafBlocksAtRange(selection).filter(function (node) {
    return node.type === BlockTypes.CODE;
  });
  return lines.reduce(function (memo, line) {
    // Insert an indent at start of line
    var text = line.nodes.first();
    return memo.insertTextByKey(text.key, 0, indent);
  }, editor);
}

export default indentLines;